import { useEffect, useRef } from 'react';
import App from './App';

export function AppWrapper() {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      console.log('App mounted once.');
    }
  }, []);

  return <App />;
}